// extracted by mini-css-extract-plugin
export var brands = "Brands-module--brands--18204";
export var container = "Brands-module--container--c30b9";
export var copy = "Brands-module--copy--d5c1f";
export var cta = "Brands-module--cta--39a91";
export var grid = "Brands-module--grid--9e8d5";
export var header = "Brands-module--header--edd4b";